import { useState, useEffect } from 'react';
import { API_BASE_URL } from '../../config';

function getStorageValue(key, defaultValue) {
    const saved = localStorage.getItem(key);
    const initial = JSON.parse(saved);
    return initial || defaultValue;
}

function saveStorageValue(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
};

const useUserInfo = (token) => {
    const key = 'userInfo';

    const [userInfo, setUserInfo] = useState(getStorageValue(key, null));
    const [loading, setLoading] = useState(!userInfo);
    const [error, setError] = useState(null);

    const fetchUserInfo = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/user/info`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            setUserInfo(data);
            saveStorageValue(key, data);
        } catch (err) {
            setError(err);
            setUserInfo(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!userInfo && token) {
            fetchUserInfo();
        }
    }, [token]);

    return { userInfo, loading, error };
};

export default useUserInfo;